import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';

declare const grecaptcha: any;

@Component({
  standalone: true,
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.css'],
  imports: [CommonModule, ReactiveFormsModule],
})
export class ReferralComponent {
  emailList: string[] = [];
  emailControl = this.fb.control('', [Validators.email]);
  captchaToken = '';
  captchaScore = 0;
  captchaResponse:any = '';
  captchaError:any = '';
  constructor(private fb: FormBuilder, private authService: AuthService) {
    this.authService.loadRecaptchaScript(true).catch(console.error);
  }

  handleCaptchaResponse(): void {
    console.log('Captcha token received:', this.captchaToken);

    this.authService.sendReferral(this.emailList, this.captchaToken).subscribe({
      next: (res:any) => {
        console.log('Auth Success:', res);
        this.captchaResponse = res;
        // this.captchaScore = res.score || 0; // Assuming the response contains a score

      },
      error: (err) => {
        console.error('Auth Failed:', err);
      }
    });
  }

  handleCaptchaError(error: any): void {
    console.error('Captcha error:', error);
    this.captchaError = error;
    this.captchaToken = '';
    this.captchaScore = 0;
    this.captchaResponse = '';
    // Additional logic to handle captcha errors
  }
  handleKey(event: KeyboardEvent) {
    const input = this.emailControl.value?.trim();
    if ((event.key === 'Enter' || event.key === ',') && input) {
      event.preventDefault();
      if (this.emailControl.valid && !this.emailList.includes(input)) {
        this.emailList.push(input);
        this.emailControl.reset();
      }
    }
  }

  removeEmail(email: string) {
    this.emailList = this.emailList.filter(e => e !== email);
  }

  async onSubmit() {
    this.captchaError = '';
    this.captchaResponse = '';
    if (this.emailList.length === 0) return;

    // Call reCAPTCHA here and send payload

    const payload = {
      emails: this.emailList,
      recaptchaToken: this.captchaToken
    };
    this.runCaptcha();

    console.log('Submitting payload:', payload);
    // POST to backend here
  }

  submitReferralWithoutToken() {
    this.authService.sendReferral(this.emailList, '').subscribe({
      next: (res:any) => {
        console.log('Auth Success:', res);
        this.captchaResponse = res;
        // this.captchaScore = res.score || 0; // Assuming the response contains a score

      },
      error: (err) => {
        console.error('Auth Failed:', err);
        this.captchaError = err;
        this.captchaToken = '';
      }
    });
  }
  runCaptcha() {

    this.authService
      .execute(true, 'submit')
      .then((token) => {
          this.captchaToken = token; // Store the token
          console.log('Captcha token:', token);
          this.handleCaptchaResponse();
        // Send token to your backend for verification
      })
      .catch(console.error);
  }
}
